"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowValidationInitializerDefinition = void 0;
/**
 * Initializes valuation in case of existing token.
 */
const WidgetInitializerPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin");
const WidgetInitializerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const ApiEndpoints_1 = require("../../../../Enum/ApiEndpoints");
class FlowValidationInitializer extends WidgetInitializerPlugin_1.default {
    constructor(definition, apiFactory) {
        super(definition);
        this.apiFactory = apiFactory;
    }
    static create(definition, container) {
        return new this(definition, container.get('factory.api'));
    }
    initialize(config, state) {
        return Promise.resolve().then(() => {
            this.restrictedValuationApi = this.apiFactory.create(ApiEndpoints_1.ApiEndpoints.RESTRICTED_VALUATION, { config });
            return this.restrictedValuationApi.restrictedValuationsCheck();
        });
    }
}
exports.default = FlowValidationInitializer;
exports.FlowValidationInitializerDefinition = new WidgetInitializerPluginDefinition_1.default({
    id: "restricted_valuation_initializer",
    class: FlowValidationInitializer,
    priority: 90
});
Mixin_1.default(FlowValidationInitializer, IContainerInjection_1.default);
